<template>
  <div class="form">
    <div class="form__disabled" v-if="disabled">
      <span class="form__disabled__message">
        <slot name="disabled">O envio de mensagens está temporariamente desativado</slot>
      </span>
    </div>
    
    <div v-else>
      <div class="form__author">
        <img class="form__author__avatar" :src="user.avatar" alt>
        <span class="form__author__name">{{ user.name }}</span>
      </div>

      <div class="form__controls">
        <InputExpandable
          v-model="message"
          class="form__controls__input"
          ref="input"
          @submit="sendMessage"
          :max-length="messageMaxLength"
          :readonly="readonly"
        />

        <div class="d-flex align-items-center justify-content-between">
          <div>
            <div v-if="errorMessage" class="form__message-error">{{ errorMessage }}</div>
          </div>

          <div class="form__controls__buttons">
            <TextCounter :max-length="messageMaxLength" :text="message" />

            <ButtonIcon
              class="size--small"
              icon-svg="PlaneSVG"
              @click="sendMessage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputExpandable from '@/components/form/InputExpandable'
import ButtonIcon from '../buttons/ButtonIcon.vue'
import TextCounter from '@/components/misc/TextCounter'

export default {
  components: {
    InputExpandable,
    ButtonIcon,
    TextCounter,
  },

  props: {
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    user: { type: Object, default: () => ({}) },
    errorMessage: { type: String, default: null }
  },

  data: () => ({
    message: '',
    messageMaxLength: 200,
    messageAvailableTimestamp: null,
  }),
  
  methods: {
    sendMessage() {
      if (this.message.length === 0) {
        return
      }

      this.$emit('send-message', this.message)
    },

    clearMessage() {
      this.message = ''
    },
  }
}
</script>

<style lang="scss" scoped>
  .form {
    &__message-error {
      font-size: 14px;
      color: #ed4337;
      line-height: 16px;;
    }

    &__disabled {
      &__message {
        font-size: 15px;
        font-weight: 700;
        color: #474747;
      }
    }
    
    &__author {
      display: flex;
      align-items: center;
      gap: 14px;

      &__avatar {
        width: 34px;
        height: 34px;
        border-radius: 100%;
      }

      &__name {
        font-family: Poppins;
        color: #474747;
        font-weight: 700;
        font-size: 14px;
      }
    }

    &__controls {
      display: flex;
      flex-direction: column;
      padding-left: 48px;
      gap: 16px;

      &__buttons {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 16px;
      }
    }
  }
</style>